/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { Card, Avatar, Col, Row, Pagination, Alert, Radio, Tooltip, Modal, Button, Select } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import logo from '../../Images/noProfile.png';
import './style.css';
import FormItem from 'antd/es/form/FormItem';
import { selectDoctorList, selectLoading, selectPageCount } from './Selectors';
import CustomSpin from '../CommonSpin';
import { BodyTextValue, ListingHeader } from '../CommonText';

import english from '../../Translations/English.json';
import hindi from '../../Translations/Hindi.json';
import malayalam from '../../Translations/Malayalam.json';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../Context';
import { checkScheduleRequest } from './Actions';

const Listing = (props) => {
    // const [currentPage, setCurrentPage] = useState(1);
    const [open, setOpen] = useState(false);
    const [residenceOpen, setresidenceOpen] = useState(false);
    const [isDomestic, setIsDomestic] = useState(false);

    const { familyGet, familyDetails } = useAuth();

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const langid = localStorage.getItem('INTL') ? (localStorage.getItem('INTL')) : 'en';
    const langdata = langid && langid == 'en' ? english : langid == 'ma' ? malayalam : langid == 'hin' ? hindi : english;

    // const dispatch = useDispatch();
    const data = useSelector(selectDoctorList);
    const requesting = useSelector(selectLoading);
    const newPayload = props.newPayload;

    useEffect(() => {
        familyGet();
    }, []);

    const handleClick = (page) => {
        props.setCurrentPage(page);
        // setCurrentPage(page);
        // dispatch(doctorListRequest(page));
        // const newPayload = JSON.parse(localStorage.getItem('payload'));

        dispatch({
            type: 'REQUEST_DOCTOR_SEARCH',
            payload:  {...newPayload, page: page }     });
    };

    const consultType = (e) => {
        const value = e.target.value;
        props.setSelectedResidence(value);
        // dispatch({
        //     type: CLICKED_DOCTOR_ID_FOR_SCHEDULE,
        //     id: doctorID,
        //     consultationTypeId: 3,
        // });
    };

    const count = useSelector(selectPageCount);
    let countTotalPage;
    if (count && count[0]) {
        countTotalPage = count[0].count;
    }
    const totalPage = (countTotalPage / 4) * 10;

    const patientId = sessionStorage.getItem('PATIENT_ID');

    let listBody = [];
    if (data && data !== undefined) {
        listBody = data && data.map((item) => (
            <div key={item.id} style={{ fontFamily: 'Roboto' }}>
                <Col style={{ marginBottom: '2%' }}>
                    <Card
                        className=""
                        actions={[
                            <div
                                key={item.id}
                                role="presentation"
                                onClick={() => {
                                    if (!sessionStorage.getItem('jwt')) {
                                        // dispatch({ type: LOGIN_ROUTE });
                                        navigate(('/login'), {state : {'locationState' : props.locality, 'hospitalState' : props.hospital, 'departmentsState' : props.spec ? props.spec[0] : null}});
                                    } else if(!patientId) {
                                        Modal.warning({
                                            title: 'Complete your profile',
                                            content: 'Please complete your profile details to book an appointment',
                                        });
                                        navigate('/addprofile');
                                    } else {
                                        // localStorage.setItem('ORG_ID', item.orgid);
                                        // localStorage.setItem('CONSULT_DOCID', item.id);
                                        // localStorage.setItem('CONSULT_TYPE', 'online');
                                        setOpen(true);
                                        props.setDoctorID(item.id);
                                        props.setOrgId(item.orgid);
                                        props.setConsultType('online');
                                    }
                                }}
                            >
                                <strong>{langdata.ConsultOnline ? langdata.ConsultOnline : 'Consult Online'}</strong>
                            </div>
                        ]}
                    >
                        <Row className="drcenter">
                            <Col
                                xs={{ span: 24 }}
                                sm={{ span: 6, offset: 2 }}
                                md={{ span: 6, offset: 2 }}
                                lg={{ span: 7, offset: 1 }}
                                xl={{ span: 6, offset: 2 }}
                                xxl={{ span: 6, offset: 2 }}
                            >
                                <Avatar
                                    style={{
                                        width: '100px',
                                        height: '100px',
                                        borderWidth: 2,
                                        borderColor: '#CACACA',
                                        borderStyle: 'double',
                                    }}
                                    src={item.profilephotourl ? item.profilephotourl : logo}
                                />
                            </Col>
                            <Col
                                xs={{ span: 24 }}
                                sm={{ span: 16 }}
                                md={{ span: 16 }}
                                lg={{ span: 16 }}
                                xl={{ span: 16 }}
                                xxl={{ span: 16 }}
                            >
                                {/* <p style={{ fontFamily: 'Roboto' }}> */}
                                <div style={{ fontWeight: 'bold' }}>
                                    <ListingHeader text={`${item.initials + item.firstName} ${item.lastName}`} />
                                </div>
                                <BodyTextValue text={item.descriptions} />
                                <br />
                                <BodyTextValue text={item.specialization} />
                                <br />
                                <BodyTextValue text={item.orgname} />
                                {/* </p> */}
                            </Col>
                        </Row>
                    </Card>
                </Col>
            </div>
        ));
    }


    const patientName = [];
    if (familyDetails) {
        familyDetails && familyDetails.map((item) => {
            patientName.push({
                value: item.id,
                label: `${item.firstName} ${item.lastName}`
            });
        });
    }

    const handleCancel = () => {
        setOpen(false);
        props.setPatientId(null);
        setresidenceOpen(false);
        props.setSelectedResidence(null);
    };
    const handleNext = () => {
        setresidenceOpen(true);
        setOpen(false);
    };

    const handleSelectPatient = (value) => {
        props.setPatientId(value);
        if (value != null) {
            familyDetails.map((item) => {
                if (item.id === value) {
                    if (item.nationality) {

                        if (item.countryCode == '+91' &&
                            (item.nationality.toLowerCase() == 'indian' ||
                                item.nationality.toLowerCase() == 'india')) {
                            setIsDomestic(true);
                        } else {
                            setIsDomestic(false);
                        }
                    } else if (item.residentCountry) {
                        if (item.countryCode == '+91' &&
                            (item.residentCountry.toLowerCase() == 'indian' ||
                                item.residentCountry.toLowerCase() == 'india')) {
                            setIsDomestic(true);
                        } else {
                            setIsDomestic(false);
                        }
                    }
                }
            });
        }
    };

    const handleNextResidence = () => {
        const payload = {
            doctorsId : props.doctorID,
            startDate : props.startDate,
            endDate : props.endDate
        };
        dispatch(checkScheduleRequest(payload));
    };

    // if (this.props.patientDetails.value !== null && this.props.patientDetails.value != undefined) {
    //   patientName = this.props.patientDetails.value.data.map(item => (
    //     <Option value={item.id}>
    //       {item.firstName} {item.lastName}
    //     </Option>
    //   ));
    // }

    const filterOption = (input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase());


    return (
        <div >
            <div>
                {listBody.length > 0 ? (
                    <div>
                        {listBody}
                        <div style={{ textAlign: 'center', display: 'flex', justifyContent: 'center', marginBottom : '1%' }}>
                            <Pagination
                                current={props.currentPage}
                                hideOnSinglePage={true}
                                onChange={handleClick}
                                total={parseInt(totalPage)}
                                showSizeChanger={false}
                            />
                        </div>
                    </div>
                ) : (
                    <div style={{ textAlign: 'center' }}>
                        <Alert message={langdata.NoDoctor ? langdata.NoDoctor : 'No Doctor!'}
                            description={langdata.SorryNoDoctoravailable ? langdata.SorryNoDoctoravailable : 'Sorry No Doctor available'} type="info" />
                    </div>
                )}
            </div>
            {/* {open && (
                <div className="dialog-overlay">
                    <div className="dialog-content">
                        <FormItem>
                            <div style={{ marginBottom: '5px' }}>Please select your type of residence</div>
                            <Radio.Group value={null} onChange={consultType}>
                                <Tooltip title="Patient residing in India">
                                    <Radio value="DOMESTIC">Domestic</Radio>
                                </Tooltip>
                                <Tooltip title="Non-resident indian patients">
                                    <Radio value="NRI">NRI</Radio>
                                </Tooltip>
                                <Tooltip title="International/Foreign patient">
                                    <Radio value="INTERNATIONAL">International</Radio>
                                </Tooltip>
                            </Radio.Group>
                        </FormItem>
                    </div>
                </div>
            )} */}

            <Modal
                open={open}
                // onOk={this.handleOk}
                onCancel={handleCancel}
                title={langdata.Choosepatient ? langdata.Choosepatient : 'Choose patient'}
                footer={[
                    <Button key="back" onClick={handleCancel}>
                        {langdata.Cancel ? langdata.Cancel : 'Cancel' }
                    </Button>,
                    props.patientId ?
                        <Button key="submit" type="primary" onClick={handleNext}>
                            {langdata.Next ? langdata.Next : 'Next'}
                        </Button>
                        : null
                ]}
            >
                {/* <p>Choose patient:</p> */}
                <div>
                    <p>
                        <Select
                            style={{ width: '100%' }}
                            placeholder={langdata.Selectapatient ? langdata.Selectapatient : 'Select a patient'}
                            value={props.patientId ? props.patientId : langdata.Selectapatient ? langdata.Selectapatient : 'Select a patient'}
                            onChange={handleSelectPatient}
                            options={patientName}
                            filterOption={filterOption}
                            showSearch
                        >
                        </Select>
                    </p>
                </div>
            </Modal>


            <Modal
                open={residenceOpen}
                // onOk={this.handleOk}
                onCancel={handleCancel}
                title={langdata.Pleaseselectyourtypeofresidence ? langdata.Pleaseselectyourtypeofresidence : 'Please select your type of residence'}

                footer={[
                    <Button key="back" onClick={handleCancel}>
                        {langdata.Cancel ? langdata.Cancel : 'Cancel' }
                    </Button>,
                    props.selectedResidence ?
                        <Button key="submit" type="primary" onClick={handleNextResidence}>
                            {langdata.Next ? langdata.Next : 'Next'}
                        </Button>
                        : null
                ]}
            >
                <FormItem>
                    {/* <div style={{ marginBottom: '5px' }}>Please select your type of residence</div> */}
                    <Radio.Group
                        value={props.selectedResidence}
                        onChange={consultType}
                    >
                        {isDomestic == true ?
                            <Row style={{
                                margin: '10px'
                            }}>
                                <Col span={24} style={{
                                    margin: '5px'
                                }}>
                                    <Tooltip title={langdata.PatientresidinginIndia ? langdata.PatientresidinginIndia : 'Patient residing in India'}>
                                        <Radio value='DOMESTIC' >{langdata.Domestic ? langdata.Domestic : 'Domestic' }</Radio>
                                    </Tooltip>
                                </Col>
                                <Col span={24} style={{
                                    margin: '5px'
                                }}>
                                    <Tooltip title={langdata.Nonresidentindianpatients ? langdata.Nonresidentindianpatients : 'Non-resident indian patients'}>
                                        <Radio value='NRI' >{langdata.NRI ? langdata.NRI : 'NRI' }</Radio>
                                    </Tooltip>
                                </Col>
                                <Col span={24} style={{
                                    margin: '5px'
                                }}>
                                    <Tooltip title={langdata.InternationalForiegnpatient ? langdata.InternationalForiegnpatient : 'International/Foriegn patient'}>
                                        <Radio value='INTERNATIONAL' >{langdata.International ? langdata.International : 'International' }</Radio>
                                    </Tooltip>
                                </Col>
                            </Row>
                            :
                            <div>
                                <Tooltip title={langdata.Nonresidentindianpatients ? langdata.Nonresidentindianpatients : 'Non-resident indian patients'}>
                                    <Radio value='NRI' >{langdata.NRI ? langdata.NRI : 'NRI' }</Radio>
                                </Tooltip>
                                <br />
                                <br />
                                <Tooltip title={langdata.InternationalForiegnpatient ? langdata.InternationalForiegnpatient : 'International/Foriegn patient' }>
                                    <Radio value='INTERNATIONAL' >{langdata.International ? langdata.International : 'International' }</Radio>
                                </Tooltip>
                            </div>
                        }
                    </Radio.Group>
                </FormItem>
            </Modal>
            <CustomSpin spinning={requesting} />

        </div>
    );
};

export default Listing;
